<template>
  <v-page-content>
    <h3><em class="fas fa-1x fa-handshake"></em> Вузы-партнеры и учреждения СПО ПАО "Газпром"</h3>

    <content-types @filter="getFilteredData" :disable="!loadedBefore"></content-types>
    <div v-if="partners && partners.length && loadedBefore">
      <b-card v-for="partner in partners" :key="partner.id.toString()"
        no-body
        border-variant="secondary"
        class="overflow-hidden mb-3"
        style="max-width: 100%;"
      >
        <b-row no-gutters>
          <b-col md="4" style="min-width: 300px;max-width: 300px;max-height: 310px;">
            <b-link :to="partner.id.toString()" append>
              <div :class="imgsForWrapp.includes(partner.id) ? 'imgWrapper' : ''">
                <b-card-img
                  width="300"
                  :src="(partner.avatar)
                    ? '/api/files/' + partner.files.find((p) =>
                      p.id === partner.avatar).physicalName
                    : defaultImage"
                  class="rounded-0" />
              </div>
            </b-link>
          </b-col>
          <b-col md="8">
            <b-card-body :title="partner.title
              ? partner.title : 'Название отсутствует'">
              <b-card-text>
                <div v-html="partner.shortDescription"></div>
              </b-card-text>
              <div class="event__statusBox">
                <b-badge :variant="$_contentMixin_getBadge(partner.status)">
                  {{ partner.status }}
                </b-badge>
              </div>
            </b-card-body>
          </b-col>
        </b-row>
      </b-card>
    </div>
    <b-alert v-else-if="loadedBefore" show variant="info" class="mx-auto">
      Вузы-партнеры и учреждения СПО отсутствуют
    </b-alert>
    <template v-else>
      <skeleton-news />
    </template>
  </v-page-content>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import contentMixin from '@/components/helpers/mixins/content-mixin'
import { statusFilters } from '@/config/content/statuses'
import SkeletonNews from '@/components/ui/skeleton/SkeletonNews.vue'

const ContentTypes = () => import('@/components/content/edit/ListGroupButtonContentTypes.vue')

export default {
  name: 'AllPartners',
  components: {
    SkeletonNews,
    ContentTypes
  },
  mixins: [contentMixin],
  data() {
    return {
      defaultImage: '/images/w1400_1.jpg',
      filters: [{
        param: 'status',
        needle: [
          statusFilters.accepted,
          statusFilters.rejected,
          statusFilters.await,
          statusFilters.draft
        ]
      }],
      loadedBefore: false,
      imgsForWrapp: []
    }
  },
  computed: {
    ...mapGetters({
      partners: 'content/getAllPartners'
    })
  },
  methods: {
    ...mapActions({
      fetchPartners: 'content/fetchAllPartners'
    }),
    getFilteredData(type) {
      this.loadedBefore = false
      if (type === 'все') {
        this.filters[0].needle = [
          statusFilters.accepted,
          statusFilters.rejected,
          statusFilters.await,
          statusFilters.draft
        ]
      } else {
        this.filters[0].needle = [type]
      }
      this.fetchPartners(this.filters).then(() => {
        this.loadedBefore = true
        this.partners.forEach((p) => {
          this.imgClass(p)
        })
      })
    },
    imgClass(partner) {
      const img = new Image()
      const imgFile = partner.files.find((p) => p.id === partner.avatar)
      if (imgFile) {
        img.src = `/api/files/${imgFile.physicalName}`
        img.onload = () => {
          if (img.width / img.height < 4 / 3 - 0.2) {
            this.imgsForWrapp.push(partner.id)
          }
        }
      }
    }
  }
}
</script>

<style scoped>
  .fade {
    opacity: 1;
  }
  .fade:hover {
    opacity: 0.6;
  }

  .imgWrapper {
    padding: 30px 70px;
    max-height: 320px;
  }
</style>
